/**
 * Recently Viewed strip (PDP only)
 * Tracks visited product handles in localStorage and renders a lightweight
 * card row for anything besides the product currently on screen. Hidden
 * entirely until there are at least 2 other products to show.
 */
(function () {
  const STORAGE_KEY = 'unplated_recently_viewed';
  const MAX_ITEMS = 8;

  const section = document.getElementById('recentlyViewedSection');
  if (!section) return;

  const currentHandle = section.dataset.currentHandle;

  function getStored() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (_) {
      return [];
    }
  }

  function recordView(handle) {
    let list = getStored().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function buildCard(p) {
    const img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
    const img2 = (p.images && p.images[1]) ? p.images[1] + (p.images[1].indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
    const title = String(p.title).replace(/"/g, '&quot;');
    return (
      '<div class="p-card">' +
        '<a href="' + p.url + '" class="p-card-inner">' +
          '<div class="p-img-wrap">' +
            (img
              ? '<img src="' + img + '" alt="' + title + '" class="p-img" loading="lazy" width="600" height="600">' + (img2 ? '<img src="' + img2 + '" alt="' + title + '" class="p-img-secondary" loading="lazy" width="600" height="600">' : '')
              : '<div class="p-placeholder-kitchen"><svg viewBox="0 0 72 72" opacity="0.3"><rect x="20" y="20" width="32" height="32" rx="4" transform="rotate(45 36 36)" fill="currentColor"/></svg></div>') +
            '<button class="p-add-v2" data-quick-add="' + p.id + '" data-handle="' + p.handle + '" aria-label="Quick Add">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="p-info-v2">' +
            '<h3 class="p-name-v2">' + title + '</h3>' +
            '<p class="p-meta-v2">' + (p.type ? p.type + ' &middot; ' : '') + 'Solid 9K Gold</p>' +
            '<div class="p-price-v2">' + formatMoney(p.price) + '</div>' +
          '</div>' +
        '</a>' +
      '</div>'
    );
  }

  function initSwiper(grid, prev, next) {
    let scrollPos = 0;

    function updateButtons() {
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      prev.disabled = scrollPos <= 0;
      next.disabled = scrollPos >= maxScroll - 10;
    }

    function move(direction) {
      const card = grid.querySelector('.p-card');
      if (!card) return;
      const cardWidth = card.offsetWidth + 24; // 1.5rem gap
      const visibleCount = Math.floor(grid.clientWidth / cardWidth) || 1;
      const moveDistance = cardWidth * visibleCount;
      const maxScroll = grid.scrollWidth - grid.clientWidth;

      if (direction === 'next') scrollPos = Math.min(scrollPos + moveDistance, maxScroll);
      else scrollPos = Math.max(scrollPos - moveDistance, 0);

      grid.style.transform = 'translateX(-' + scrollPos + 'px)';
      updateButtons();
    }

    prev.addEventListener('click', function () { move('prev'); });
    next.addEventListener('click', function () { move('next'); });

    window.addEventListener('resize', function () {
      scrollPos = 0;
      grid.style.transform = 'translateX(0)';
      updateButtons();
    });

    let startX = 0;
    grid.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    grid.addEventListener('touchend', function (e) {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) move(diff > 0 ? 'next' : 'prev');
    }, { passive: true });

    setTimeout(updateButtons, 500);
  }

  function renderStrip() {
    const handles = getStored().filter(function (h) { return h !== currentHandle; }).slice(0, 8);
    if (handles.length < 2) return;

    Promise.allSettled(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) {
          if (!r.ok) throw new Error('not found');
          return r.json();
        });
      })
    ).then(function (results) {
      const products = results
        .filter(function (r) { return r.status === 'fulfilled'; })
        .map(function (r) { return r.value; })
        .filter(function (p) { return p.price > 0; });

      if (products.length < 2) return;

      const grid = document.getElementById('recently-viewed-products');
      if (!grid) return;
      grid.innerHTML = products.map(buildCard).join('');
      section.hidden = false;

      const prev = document.getElementById('recentPrev');
      const next = document.getElementById('recentNext');
      if (prev && next) initSwiper(grid, prev, next);
    });
  }

  if (currentHandle) recordView(currentHandle);
  renderStrip();
})();
